import { useContext, useRef, useState } from 'react'

import { Box, Button, Icon, Spinner, Text } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { ProvidersMap } from '../../components/ProvidersMap/providers-map.comp'

import { AddProvider } from './components/AddProvider/add-provider.comp'
import { ProviderCards } from './components/ProvidersCards/providers-cards.comp'
import { ProvidersTable } from './components/ProvidersTable/providers-table.comp'
import { ProvidersContext, ProvidersProvider } from './providers.context'

const ProvidersComp = () => {
  const [openAddProviderModal, setOpenAddProviderModal] =
    useState<boolean>(false)

  const { loading } = useContext(ProvidersContext)

  const providersMapRef = useRef<any>(null)

  const handleSubmitAddProvider = async () => {
    if (providersMapRef.current) {
      providersMapRef.current.refreshProvidersMap()
    }
  }

  const theme = useTheme()

  return !loading ? (
    <Box width="100%" direction="column" gap={3} padding={3}>
      <Box width="100%" justifyContent="space-between" flexWrap="wrap" gap={3}>
        <Text>Lista de Fornecedores</Text>
        <Button
          fontSize="small"
          padding={`${theme.spacing['1']} ${theme.spacing['2']}`}
          onClick={() => setOpenAddProviderModal(true)}
        >
          <Icon name="add" size={20} color={theme.colors.custom.white} />
          Adicionar fornecedor
        </Button>
      </Box>
      <ProviderCards />
      <Box width="100%" height="100%">
        <ProvidersTable />
      </Box>
      <ProvidersMap ref={providersMapRef} />

      <AddProvider
        open={openAddProviderModal}
        setOpen={setOpenAddProviderModal}
        onSubmit={() => handleSubmitAddProvider()}
      />
    </Box>
  ) : (
    <Box
      width="100%"
      height="100%"
      padding={3}
      alignItems="center"
      justifyContent="center"
    >
      <Spinner size="40px" />
    </Box>
  )
}

export const Providers = () => {
  return (
    <ProvidersProvider>
      <ProvidersComp />
    </ProvidersProvider>
  )
}
